// This file was auto-generated by Fern from our API Definition.
export var DiscoveredTool;
(function (DiscoveredTool) {
    DiscoveredTool.Type = {
        Gateway: "gateway",
    };
})(DiscoveredTool || (DiscoveredTool = {}));
